
import { supabase } from '@/lib/supabase';
import { handleError, ErrorSeverity } from '@/utils/errorHandler';

export const uploadStaffPhoto = async (photoFile: File, staffId: string): Promise<string | null> => {
  try {
    const fileExt = photoFile.name.split('.').pop();
    const fileName = `${staffId}-${Math.random()}.${fileExt}`;

    const { data, error: uploadError } = await supabase.storage
      .from('staff-photos')
      .upload(fileName, photoFile);

    if (uploadError) throw uploadError;

    // Get the base public URL
    const { data: { publicUrl } } = supabase.storage
      .from('staff-photos')
      .getPublicUrl(data.path);

    // Use Supabase image transformation to create a square avatar optimized for circles
    // This creates a 200x200 square image, which works perfectly for circular avatars
    const transformedUrl = `${publicUrl}?width=200&height=200&resize=cover&format=webp`;

    return transformedUrl;
  } catch (error) {
    handleError(
      error,
      "Failed to upload staff photo",
      ErrorSeverity.ERROR,
      { operation: 'uploadStaffPhoto' }
    );
    return null;
  }
};

